import storefront from './storefront';
import user from './user';
import auth from './auth';
import addresses from './addresses';
import postalCodes from './postalCodes';
import orders from './orders';
import ui from './ui';

export default { storefront, auth, user, addresses, postalCodes, orders, ui };
